import { ExtensionIdentifierMap } from 'vscode/vscode/vs/platform/extensions/common/extensions';
import { localizeWithPath } from 'vscode/vscode/vs/nls';
import { semverExports } from 'vscode/external/vscode-semver/semver.js';

const _moduleId = "vs/workbench/services/extensions/common/extensionsUtil";
function dedupExtensions(system, user, development, logService) {
    const result = ( (new ExtensionIdentifierMap()));
    system.forEach((systemExtension) => {
        const extension = result.get(systemExtension.identifier);
        if (extension) {
            logService.warn(( localizeWithPath(
                _moduleId,
                0,
                "Overwriting extension {0} with {1}.",
                extension.extensionLocation.fsPath,
                systemExtension.extensionLocation.fsPath
            )));
        }
        result.set(systemExtension.identifier, systemExtension);
    });
    user.forEach((userExtension) => {
        const extension = result.get(userExtension.identifier);
        if (extension) {
            if (extension.isBuiltin) {
                if (semverExports.gte(extension.version, userExtension.version)) {
                    logService.warn(`Skipping extension ${userExtension.extensionLocation.path} in favour of the builtin extension ${extension.extensionLocation.path}.`);
                    return;
                }
                userExtension.isBuiltin = true;
            }
            else {
                logService.warn(( localizeWithPath(
                    _moduleId,
                    0,
                    "Overwriting extension {0} with {1}.",
                    extension.extensionLocation.fsPath,
                    userExtension.extensionLocation.fsPath
                )));
            }
        }
        else if (userExtension.isBuiltin) {
            logService.warn(`Skipping obsolete builtin extension ${userExtension.extensionLocation.path}`);
            return;
        }
        result.set(userExtension.identifier, userExtension);
    });
    development.forEach(developedExtension => {
        logService.info(( localizeWithPath(
            _moduleId,
            1,
            "Loading development extension at {0}",
            developedExtension.extensionLocation.fsPath
        )));
        const extension = result.get(developedExtension.identifier);
        if (extension) {
            if (extension.isBuiltin) {
                developedExtension.isBuiltin = true;
            }
        }
        result.set(developedExtension.identifier, developedExtension);
    });
    return Array.from(( (result.values())));
}

export { dedupExtensions };
